import type { ILanguageResources, ITranslationModule } from '../../../interfaces';
import { interpolate } from '../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.fabricationPurchaseOrders.FabricationPurchaseOrder.';
  public static readonly draftTab = `${Id.prefix}draftTab`;
  public static readonly issuedTab = `${Id.prefix}issuedTab`;
  public static readonly issuedPendingState = `${Id.prefix}issuedPendingState`;
  public static readonly completedTab = `${Id.prefix}completedTab`;
  public static readonly cancelledTab = `${Id.prefix}cancelledTab`;
  public static readonly numberColumn = `${Id.prefix}numberColumn`;
  public static readonly titleColumn = `${Id.prefix}titleColumn`;
  public static readonly stateColumn = `${Id.prefix}stateColumn`;
  public static readonly itemsColumn = `${Id.prefix}itemsColumn`;
  public static readonly linkedJobsColumn = `${Id.prefix}linkedJobsColumn`;
  public static readonly createdColumn = `${Id.prefix}createdColumn`;
  public static readonly authorColumn = `${Id.prefix}authorColumn`;
  public static readonly itemsTab = `${Id.prefix}itemsTab`;
  public static readonly linkedJobsTab = `${Id.prefix}linkedJobsTab`;
  public static readonly informationTab = `${Id.prefix}informationTab`;
  public static readonly titleLabel = `${Id.prefix}titleLabel`;
  public static readonly descriptionLabel = `${Id.prefix}descriptionLabel`;
  public static readonly authorLabel = `${Id.prefix}authorLabel`;
  public static readonly statusButton = `${Id.prefix}statusButton`;
  public static readonly cancelAction = `${Id.prefix}cancelAction`;
  public static readonly cancelConfirm = `${Id.prefix}cancelConfirm`;
  public static readonly cancelConfirmSupplierMayHold = `${Id.prefix}cancelConfirmSupplierMayHold`;
  public static readonly cancelledToast = `${Id.prefix}cancelledToast`;
  public static readonly completeAction = `${Id.prefix}completeAction`;
  public static readonly completeConfirm = `${Id.prefix}completeConfirm`;
  public static readonly completedToast = `${Id.prefix}completedToast`;
  public static readonly issueAction = `${Id.prefix}issueAction`;
  public static readonly issueConfirm = `${Id.prefix}issueConfirm`;
  public static readonly issuedPendingToast = `${Id.prefix}issuedPendingToast`;
  public static readonly issueNoItems = `${Id.prefix}issueNoItems`;
  public static readonly issueNoOrderableItems = `${Id.prefix}issueNoOrderableItems`;
  public static readonly lineSetLocked = `${Id.prefix}lineSetLocked`;
  public static readonly priceColumn = `${Id.prefix}priceColumn`;
  public static readonly totalLabel = `${Id.prefix}totalLabel`;
  public static readonly supplierStatusHeading = `${Id.prefix}supplierStatusHeading`;
  public static readonly referenceLabel = `${Id.prefix}referenceLabel`;
  public static readonly supplierStatusLabel = `${Id.prefix}supplierStatusLabel`;
  public static readonly deliveryDateLabel = `${Id.prefix}deliveryDateLabel`;
  public static readonly closedDateLabel = `${Id.prefix}closedDateLabel`;
  public static readonly leadTimeLabel = `${Id.prefix}leadTimeLabel`;
  public static readonly removeLineAction = `${Id.prefix}removeLineAction`;
  public static readonly addToPoMenu = `${Id.prefix}addToPoMenu`;
  public static readonly addToPoBadge = `${Id.prefix}addToPoBadge`;
  public static readonly addToPoDialogTitle = `${Id.prefix}addToPoDialogTitle`;
  public static readonly createNewPo = `${Id.prefix}createNewPo`;
  public static readonly addToPoCancel = `${Id.prefix}addToPoCancel`;
  public static readonly newPoDefaultTitle = `${Id.prefix}newPoDefaultTitle`;
  public static readonly newPoButton = `${Id.prefix}newPoButton`;
  public static readonly addedToPoToast = `${Id.prefix}addedToPoToast`;
  public static readonly createdPoToast = `${Id.prefix}createdPoToast`;
  public static readonly supplierUnavailable = `${Id.prefix}supplierUnavailable`;
  public static readonly typeColumn = `${Id.prefix}typeColumn`;
  public static readonly descriptionColumn = `${Id.prefix}descriptionColumn`;
  public static readonly finishColumn = `${Id.prefix}finishColumn`;
  public static readonly dimensionsColumn = `${Id.prefix}dimensionsColumn`;
  public static readonly quantityColumn = `${Id.prefix}quantityColumn`;
  public static readonly invalidLengthError = `${Id.prefix}invalidLengthError`;
  public static readonly lengthCheckOffline = `${Id.prefix}lengthCheckOffline`;
  public static readonly lengthEditUnsupported = `${Id.prefix}lengthEditUnsupported`;
  public static readonly noLengthsAvailable = `${Id.prefix}noLengthsAvailable`;
  public static readonly noFinishesAvailable = `${Id.prefix}noFinishesAvailable`;
  public static readonly adHocItemsUnsupported = `${Id.prefix}adHocItemsUnsupported`;
  public static readonly packSizeTooltip = `${Id.prefix}packSizeTooltip`;
  public static readonly rollLengthTooltip = `${Id.prefix}rollLengthTooltip`;
  public static readonly componentNotPackedTooltip = `${Id.prefix}componentNotPackedTooltip`;
  public static readonly gasketNotRolledTooltip = `${Id.prefix}gasketNotRolledTooltip`;
  public static readonly sourceColumn = `${Id.prefix}sourceColumn`;
  public static readonly materialTypeExtrusion = `${Id.prefix}materialTypeExtrusion`;
  public static readonly materialTypeComponent = `${Id.prefix}materialTypeComponent`;
  public static readonly materialTypeGasket = `${Id.prefix}materialTypeGasket`;
  public static readonly materialTypeFill = `${Id.prefix}materialTypeFill`;
  public static readonly typeFilterAll = `${Id.prefix}typeFilterAll`;
  public static readonly typeFilterExtrusions = `${Id.prefix}typeFilterExtrusions`;
  public static readonly typeFilterGaskets = `${Id.prefix}typeFilterGaskets`;
  public static readonly typeFilterComponents = `${Id.prefix}typeFilterComponents`;
  public static readonly typeFilterGlass = `${Id.prefix}typeFilterGlass`;
  public static readonly sourceSupplier = `${Id.prefix}sourceSupplier`;
  public static readonly sourceExternal = `${Id.prefix}sourceExternal`;
  public static readonly onPurchaseOrdersColumn = `${Id.prefix}onPurchaseOrdersColumn`;
  public static readonly purchaseOrdersLabel = `${Id.prefix}purchaseOrdersLabel`;
  public static readonly alreadyOnPoWarning = `${Id.prefix}alreadyOnPoWarning`;
  public static readonly detailPageTitle = `${Id.prefix}detailPageTitle`;
  public static readonly pickExtrusionTitle = `${Id.prefix}pickExtrusionTitle`;
  public static readonly pickComponentTitle = `${Id.prefix}pickComponentTitle`;
  public static readonly pickGasketTitle = `${Id.prefix}pickGasketTitle`;
  public static readonly pickGlassTitle = `${Id.prefix}pickGlassTitle`;
  public static readonly pickFinishTitle = `${Id.prefix}pickFinishTitle`;
  public static readonly pickLengthTitle = `${Id.prefix}pickLengthTitle`;
  public static readonly pickerFinishCodeColumn = `${Id.prefix}pickerFinishCodeColumn`;
  public static readonly pickerDescriptionColumn = `${Id.prefix}pickerDescriptionColumn`;
  public static readonly pickerLengthColumn = `${Id.prefix}pickerLengthColumn`;
  public static readonly pickerCategoryColumn = `${Id.prefix}pickerCategoryColumn`;
  public static readonly lengthStandard = `${Id.prefix}lengthStandard`;
  public static readonly lengthSpecial = `${Id.prefix}lengthSpecial`;
  public static readonly pickerCancel = `${Id.prefix}pickerCancel`;
  public static readonly addExtrusion = `${Id.prefix}addExtrusion`;
  public static readonly addComponent = `${Id.prefix}addComponent`;
  public static readonly addGasket = `${Id.prefix}addGasket`;
  public static readonly addFill = `${Id.prefix}addFill`;
  public static readonly fillSizeTitle = `${Id.prefix}fillSizeTitle`;
  public static readonly fillWidthLabel = `${Id.prefix}fillWidthLabel`;
  public static readonly fillHeightLabel = `${Id.prefix}fillHeightLabel`;
  public static readonly gasketLengthTitle = `${Id.prefix}gasketLengthTitle`;
  public static readonly gasketLengthLabel = `${Id.prefix}gasketLengthLabel`;
  public static readonly measurementOk = `${Id.prefix}measurementOk`;
  public static readonly measurementCancel = `${Id.prefix}measurementCancel`;
}

export class LangFabricationPurchaseOrder {
  private constructor() {}
  public static draftTab(): string {
    return interpolate(Id.draftTab);
  }
  public static issuedTab(): string {
    return interpolate(Id.issuedTab);
  }
  public static issuedPendingState(): string {
    return interpolate(Id.issuedPendingState);
  }
  public static completedTab(): string {
    return interpolate(Id.completedTab);
  }
  public static cancelledTab(): string {
    return interpolate(Id.cancelledTab);
  }
  public static numberColumn(): string {
    return interpolate(Id.numberColumn);
  }
  public static titleColumn(): string {
    return interpolate(Id.titleColumn);
  }
  public static stateColumn(): string {
    return interpolate(Id.stateColumn);
  }
  public static itemsColumn(): string {
    return interpolate(Id.itemsColumn);
  }
  public static linkedJobsColumn(): string {
    return interpolate(Id.linkedJobsColumn);
  }
  public static createdColumn(): string {
    return interpolate(Id.createdColumn);
  }
  public static authorColumn(): string {
    return interpolate(Id.authorColumn);
  }
  public static itemsTab(): string {
    return interpolate(Id.itemsTab);
  }
  public static linkedJobsTab(): string {
    return interpolate(Id.linkedJobsTab);
  }
  public static informationTab(): string {
    return interpolate(Id.informationTab);
  }
  public static titleLabel(): string {
    return interpolate(Id.titleLabel);
  }
  public static descriptionLabel(): string {
    return interpolate(Id.descriptionLabel);
  }
  public static authorLabel(): string {
    return interpolate(Id.authorLabel);
  }
  public static statusButton(): string {
    return interpolate(Id.statusButton);
  }
  public static cancelAction(): string {
    return interpolate(Id.cancelAction);
  }
  public static cancelConfirm(): string {
    return interpolate(Id.cancelConfirm);
  }
  public static cancelConfirmSupplierMayHold(purchaseOrderNumber: number): string {
    return interpolate(Id.cancelConfirmSupplierMayHold, { purchaseOrderNumber });
  }
  public static cancelledToast(): string {
    return interpolate(Id.cancelledToast);
  }
  public static completeAction(): string {
    return interpolate(Id.completeAction);
  }
  public static completeConfirm(purchaseOrderNumber: number): string {
    return interpolate(Id.completeConfirm, { purchaseOrderNumber });
  }
  public static completedToast(): string {
    return interpolate(Id.completedToast);
  }
  public static issueAction(): string {
    return interpolate(Id.issueAction);
  }
  public static issueConfirm(): string {
    return interpolate(Id.issueConfirm);
  }
  public static issuedPendingToast(): string {
    return interpolate(Id.issuedPendingToast);
  }
  public static issueNoItems(): string {
    return interpolate(Id.issueNoItems);
  }
  public static issueNoOrderableItems(): string {
    return interpolate(Id.issueNoOrderableItems);
  }
  public static lineSetLocked(): string {
    return interpolate(Id.lineSetLocked);
  }
  public static priceColumn(): string {
    return interpolate(Id.priceColumn);
  }
  public static totalLabel(): string {
    return interpolate(Id.totalLabel);
  }
  public static supplierStatusHeading(): string {
    return interpolate(Id.supplierStatusHeading);
  }
  public static referenceLabel(): string {
    return interpolate(Id.referenceLabel);
  }
  public static supplierStatusLabel(): string {
    return interpolate(Id.supplierStatusLabel);
  }
  public static deliveryDateLabel(): string {
    return interpolate(Id.deliveryDateLabel);
  }
  public static closedDateLabel(): string {
    return interpolate(Id.closedDateLabel);
  }
  public static leadTimeLabel(): string {
    return interpolate(Id.leadTimeLabel);
  }
  public static removeLineAction(): string {
    return interpolate(Id.removeLineAction);
  }
  public static addToPoMenu(): string {
    return interpolate(Id.addToPoMenu);
  }

  public static addToPoBadge(): string {
    return interpolate(Id.addToPoBadge);
  }
  public static addToPoDialogTitle(): string {
    return interpolate(Id.addToPoDialogTitle);
  }
  public static createNewPo(): string {
    return interpolate(Id.createNewPo);
  }
  public static addToPoCancel(): string {
    return interpolate(Id.addToPoCancel);
  }
  public static newPoDefaultTitle(): string {
    return interpolate(Id.newPoDefaultTitle);
  }
  public static newPoButton(): string {
    return interpolate(Id.newPoButton);
  }
  public static addedToPoToast(): string {
    return interpolate(Id.addedToPoToast);
  }
  public static createdPoToast(): string {
    return interpolate(Id.createdPoToast);
  }
  public static supplierUnavailable(): string {
    return interpolate(Id.supplierUnavailable);
  }
  public static typeColumn(): string {
    return interpolate(Id.typeColumn);
  }
  public static descriptionColumn(): string {
    return interpolate(Id.descriptionColumn);
  }
  public static finishColumn(): string {
    return interpolate(Id.finishColumn);
  }
  public static dimensionsColumn(): string {
    return interpolate(Id.dimensionsColumn);
  }
  public static quantityColumn(): string {
    return interpolate(Id.quantityColumn);
  }
  public static invalidLengthError(): string {
    return interpolate(Id.invalidLengthError);
  }
  public static lengthCheckOffline(): string {
    return interpolate(Id.lengthCheckOffline);
  }
  public static lengthEditUnsupported(): string {
    return interpolate(Id.lengthEditUnsupported);
  }
  public static noLengthsAvailable(): string {
    return interpolate(Id.noLengthsAvailable);
  }
  public static noFinishesAvailable(): string {
    return interpolate(Id.noFinishesAvailable);
  }
  public static adHocItemsUnsupported(): string {
    return interpolate(Id.adHocItemsUnsupported);
  }
  public static packSizeTooltip(packSize: string): string {
    return interpolate(Id.packSizeTooltip, { packSize });
  }
  public static rollLengthTooltip(rollLength: string): string {
    return interpolate(Id.rollLengthTooltip, { rollLength });
  }
  public static componentNotPackedTooltip(): string {
    return interpolate(Id.componentNotPackedTooltip);
  }
  public static gasketNotRolledTooltip(): string {
    return interpolate(Id.gasketNotRolledTooltip);
  }
  public static sourceColumn(): string {
    return interpolate(Id.sourceColumn);
  }
  public static materialTypeExtrusion(): string {
    return interpolate(Id.materialTypeExtrusion);
  }
  public static materialTypeComponent(): string {
    return interpolate(Id.materialTypeComponent);
  }
  public static materialTypeGasket(): string {
    return interpolate(Id.materialTypeGasket);
  }
  public static materialTypeFill(): string {
    return interpolate(Id.materialTypeFill);
  }
  public static typeFilterAll(): string {
    return interpolate(Id.typeFilterAll);
  }
  public static typeFilterExtrusions(): string {
    return interpolate(Id.typeFilterExtrusions);
  }
  public static typeFilterGaskets(): string {
    return interpolate(Id.typeFilterGaskets);
  }
  public static typeFilterComponents(): string {
    return interpolate(Id.typeFilterComponents);
  }
  public static typeFilterGlass(): string {
    return interpolate(Id.typeFilterGlass);
  }
  public static sourceSupplier(): string {
    return interpolate(Id.sourceSupplier);
  }
  public static sourceExternal(): string {
    return interpolate(Id.sourceExternal);
  }
  public static onPurchaseOrdersColumn(): string {
    return interpolate(Id.onPurchaseOrdersColumn);
  }

  public static purchaseOrdersLabel(): string {
    return interpolate(Id.purchaseOrdersLabel);
  }

  public static alreadyOnPoWarning(purchaseOrders: string): string {
    return interpolate(Id.alreadyOnPoWarning, { purchaseOrders });
  }
  public static detailPageTitle(): string {
    return interpolate(Id.detailPageTitle);
  }
  public static pickExtrusionTitle(): string {
    return interpolate(Id.pickExtrusionTitle);
  }
  public static pickComponentTitle(): string {
    return interpolate(Id.pickComponentTitle);
  }
  public static pickGasketTitle(): string {
    return interpolate(Id.pickGasketTitle);
  }
  public static pickGlassTitle(): string {
    return interpolate(Id.pickGlassTitle);
  }
  public static pickFinishTitle(): string {
    return interpolate(Id.pickFinishTitle);
  }
  public static pickLengthTitle(): string {
    return interpolate(Id.pickLengthTitle);
  }
  public static pickerFinishCodeColumn(): string {
    return interpolate(Id.pickerFinishCodeColumn);
  }
  public static pickerDescriptionColumn(): string {
    return interpolate(Id.pickerDescriptionColumn);
  }
  public static pickerLengthColumn(): string {
    return interpolate(Id.pickerLengthColumn);
  }
  public static pickerCategoryColumn(): string {
    return interpolate(Id.pickerCategoryColumn);
  }
  public static lengthStandard(): string {
    return interpolate(Id.lengthStandard);
  }
  public static lengthSpecial(): string {
    return interpolate(Id.lengthSpecial);
  }
  public static pickerCancel(): string {
    return interpolate(Id.pickerCancel);
  }
  public static addExtrusion(): string {
    return interpolate(Id.addExtrusion);
  }
  public static addComponent(): string {
    return interpolate(Id.addComponent);
  }
  public static addGasket(): string {
    return interpolate(Id.addGasket);
  }
  public static addFill(): string {
    return interpolate(Id.addFill);
  }
  public static fillSizeTitle(): string {
    return interpolate(Id.fillSizeTitle);
  }
  public static fillWidthLabel(): string {
    return interpolate(Id.fillWidthLabel);
  }
  public static fillHeightLabel(): string {
    return interpolate(Id.fillHeightLabel);
  }
  public static gasketLengthTitle(): string {
    return interpolate(Id.gasketLengthTitle);
  }
  public static gasketLengthLabel(): string {
    return interpolate(Id.gasketLengthLabel);
  }
  public static measurementOk(): string {
    return interpolate(Id.measurementOk);
  }
  public static measurementCancel(): string {
    return interpolate(Id.measurementCancel);
  }
}

export class FabricationPurchaseOrderModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.draftTab, 'Draft', 'PO list Draft tab');
    register.add(Id.issuedTab, 'Issued', 'PO list Issued tab');
    register.add(Id.issuedPendingState, 'Issuing', 'PO state label while the async issue flow is in progress');
    register.add(Id.completedTab, 'Completed', 'PO list Completed tab');
    register.add(Id.cancelledTab, 'Cancelled', 'PO list Cancelled tab');
    register.add(Id.numberColumn, 'PO #', 'PO list number column');
    register.add(Id.titleColumn, 'Title', 'PO list title column');
    register.add(Id.stateColumn, 'Status', 'PO list status column');
    register.add(Id.itemsColumn, 'Items', 'PO list item-count column');
    register.add(Id.linkedJobsColumn, 'Jobs', 'PO list linked-job-count column');
    register.add(Id.createdColumn, 'Created', 'PO list created column');
    register.add(Id.authorColumn, "{{glossary 'author'}}", 'PO list author column');
    register.add(Id.itemsTab, 'Line Items', 'PO detail items tab');
    register.add(Id.linkedJobsTab, 'Linked Jobs', 'PO detail linked jobs tab');
    register.add(Id.informationTab, 'Information', 'PO detail information tab');
    register.add(Id.titleLabel, 'Title', 'PO header title field');
    register.add(Id.descriptionLabel, 'Description', 'PO header description field');
    register.add(Id.authorLabel, 'Author', 'PO header author field');
    register.add(
      Id.statusButton,
      'Status',
      'Footer drop-up button on the fabrication purchase order that lists the legal next states'
    );
    register.add(Id.cancelAction, 'Cancel Purchase Order', 'PO cancel action');
    register.add(Id.cancelConfirm, 'Cancel this purchase order? This cannot be undone.', 'PO cancel confirmation');
    register.add(
      Id.cancelConfirmSupplierMayHold,
      'Purchase order {{purchaseOrderNumber}} has already been sent to your supplier. They may already be working on it, and cancelling here does not tell them - you must contact them directly. Cancel anyway? This cannot be undone.',
      'PO cancel confirmation when the order is issued or a supplier quote may already exist'
    );
    register.add(Id.cancelledToast, 'Purchase order cancelled', 'PO cancelled success toast');
    register.add(Id.completeAction, 'Complete Purchase Order', 'PO complete action');
    register.add(
      Id.completeConfirm,
      'Mark purchase order {{purchaseOrderNumber}} as completed? This cannot be undone.',
      'PO complete confirmation'
    );
    register.add(Id.completedToast, 'Purchase order completed', 'PO completed success toast');
    register.add(Id.issueAction, 'Issue to Supplier', 'PO issue action');
    register.add(Id.issueConfirm, 'Issue this purchase order to the supplier?', 'PO issue confirmation');
    register.add(Id.issuedPendingToast, 'Issuing purchase order...', 'PO issuing in-progress toast');
    register.add(Id.issueNoItems, 'Add at least one line before issuing.', 'PO issue blocked: no lines');
    register.add(
      Id.issueNoOrderableItems,
      'Add at least one supplier-sourced line before issuing.',
      'PO issue blocked: every line is externally sourced, so there is nothing to order'
    );
    register.add(
      Id.lineSetLocked,
      'This purchase order may already have been sent to the supplier, so its lines can no longer be changed. You can still re-issue it as it stands - contact your supplier to change or cancel the order.',
      'PO items notice: the lines are frozen because a supplier quote may already exist for them'
    );
    register.add(Id.priceColumn, 'Price', 'PO items per-line supplier price column');
    register.add(Id.totalLabel, 'Order total', 'PO items supplier order total label');
    register.add(Id.supplierStatusHeading, 'Supplier Status', 'PO information supplier-status section heading');
    register.add(Id.referenceLabel, 'Supplier Reference', 'PO information supplier quote reference label');
    register.add(Id.supplierStatusLabel, 'Status', 'PO information supplier-reported status label');
    register.add(Id.deliveryDateLabel, 'Expected Delivery', 'PO information supplier delivery date label');
    register.add(Id.closedDateLabel, 'Closed Date', 'PO information supplier closed date label');
    register.add(Id.leadTimeLabel, 'Shipping Lead Time (days)', 'PO information supplier lead time label');
    register.add(Id.removeLineAction, 'Remove Line', 'PO remove line action');
    register.add(Id.addToPoMenu, 'Add to Purchase Order', 'Job row add-to-PO menu item');
    register.add(Id.addToPoBadge, 'Add To', 'Job list badge shown when a job is on no purchase order');
    register.add(Id.addToPoDialogTitle, 'Select a Draft Purchase Order', 'Add-to-PO dialog title');
    register.add(Id.createNewPo, 'Create New Purchase Order', 'Add-to-PO create-new button');
    register.add(Id.addToPoCancel, 'Cancel', 'Add-to-PO dialog cancel button');
    register.add(Id.newPoDefaultTitle, 'New Purchase Order', 'Default title for a PO created from a job');
    register.add(Id.newPoButton, 'Create Purchase Order', 'PO list toolbar button to create an empty purchase order');
    register.add(Id.addedToPoToast, 'Job added to purchase order', 'Toast after adding a job to an existing PO');
    register.add(Id.createdPoToast, 'Purchase order created', 'Toast after creating a new PO from a job');
    register.add(
      Id.supplierUnavailable,
      'Supplier is not available; cannot create a purchase order right now.',
      'Message when the parent supplier could not be resolved for PO creation'
    );
    register.add(Id.typeColumn, 'Type', 'PO items material-type column');
    register.add(Id.descriptionColumn, 'Description', 'PO items description column');
    register.add(Id.finishColumn, 'Finish', 'PO items finish column');
    register.add(Id.dimensionsColumn, 'Dimensions', 'PO items dimensions column');
    register.add(Id.quantityColumn, 'Quantity', 'PO items quantity column');
    register.add(Id.invalidLengthError, 'Enter a valid length.', 'PO items length parse rejected the typed text');
    register.add(
      Id.lengthCheckOffline,
      'Could not reach the supplier to check the length. It may be offline.',
      'PO items length parse failed because the V6/supplier call did not complete'
    );
    register.add(
      Id.lengthEditUnsupported,
      'This supplier needs a newer V6 version to edit lengths.',
      'PO items length edit blocked because the loaded frame config predates measurement parsing (hasMeasurementParsing)'
    );
    register.add(
      Id.noLengthsAvailable,
      'No lengths available for this extrusion and finish.',
      'PO ad-hoc extrusion length picker found no lengths to choose from'
    );
    register.add(
      Id.noFinishesAvailable,
      'No finishes available for this resource.',
      'PO ad-hoc finish picker found no finishes to choose from'
    );
    register.add(
      Id.adHocItemsUnsupported,
      'This supplier needs a newer V6 version to add this item type.',
      'PO ad-hoc add blocked because the supplier is too old to build/optimize/issue the order (macro 13.1.13)'
    );
    register.add(Id.packSizeTooltip, '{{packSize}} per pack', 'PO items info tooltip on the (N packs) hint');
    register.add(Id.rollLengthTooltip, 'Roll length: {{rollLength}}', 'PO items info tooltip on the (N rolls) hint');
    register.add(
      Id.componentNotPackedTooltip,
      'Component is not supplied in pack',
      'PO items info tooltip for a component with no pack size'
    );
    register.add(
      Id.gasketNotRolledTooltip,
      'Gasket is not supplied in roll',
      'PO items info tooltip for a gasket with no roll length'
    );
    register.add(Id.sourceColumn, 'Source', 'PO items source column');
    register.add(Id.materialTypeExtrusion, 'Extrusion', 'PO item material type extrusion');
    register.add(Id.materialTypeComponent, 'Component', 'PO item material type component');
    register.add(Id.materialTypeGasket, 'Gasket', 'PO item material type gasket');
    register.add(Id.materialTypeFill, 'Glass', 'PO item material type fill (glass)');
    register.add(Id.typeFilterAll, 'All', 'PO items type-filter radio: all types');
    register.add(Id.typeFilterExtrusions, 'Extrusions', 'PO items type-filter radio: extrusions only');
    register.add(Id.typeFilterGaskets, 'Gaskets', 'PO items type-filter radio: gaskets only');
    register.add(Id.typeFilterComponents, 'Components', 'PO items type-filter radio: components only');
    register.add(Id.typeFilterGlass, 'Glass', 'PO items type-filter radio: glass (fill) only');
    register.add(Id.sourceSupplier, 'Supplier', 'PO item source supplier');
    register.add(Id.sourceExternal, 'Externally Sourced', 'PO item source external');
    register.add(Id.onPurchaseOrdersColumn, 'Purchase Orders', 'Job list column showing POs a job is on');
    register.add(
      Id.purchaseOrdersLabel,
      'Purchase Order(s):',
      'Label before the job detail footer list of purchase orders'
    );
    register.add(
      Id.alreadyOnPoWarning,
      'This job is already on {{purchaseOrders}}. Add it to another purchase order?',
      'Warns that a job is already on a purchase order before adding it to another'
    );
    register.add(Id.detailPageTitle, 'Purchase Order', 'PO detail page browser title');
    register.add(Id.pickExtrusionTitle, 'Select an Extrusion', 'Ad-hoc PO line extrusion picker title');
    register.add(Id.pickComponentTitle, 'Select a Component', 'Ad-hoc PO line component picker title');
    register.add(Id.pickGasketTitle, 'Select a Gasket', 'Ad-hoc PO line gasket picker title');
    register.add(Id.pickGlassTitle, 'Select Glass', 'Ad-hoc PO line glass (fill) picker title');
    register.add(Id.pickFinishTitle, 'Select a Finish', 'Ad-hoc PO line finish picker title');
    register.add(Id.pickLengthTitle, 'Select a Length', 'Ad-hoc PO line extrusion length picker title');
    register.add(Id.pickerFinishCodeColumn, 'Code', 'Ad-hoc PO line finish picker code column');
    register.add(Id.pickerDescriptionColumn, 'Description', 'Ad-hoc PO line picker description column');
    register.add(Id.pickerLengthColumn, 'Length', 'Ad-hoc PO line extrusion length picker length column');
    register.add(Id.pickerCategoryColumn, 'Category', 'Ad-hoc PO line extrusion length picker category column');
    register.add(Id.lengthStandard, 'Standard', 'Ad-hoc PO line extrusion length standard category badge');
    register.add(Id.lengthSpecial, 'Special', 'Ad-hoc PO line extrusion length special category badge');
    register.add(Id.pickerCancel, 'Cancel', 'Ad-hoc PO line picker cancel button');
    register.add(Id.addExtrusion, 'Add Extrusion', 'PO detail add extrusion line button');
    register.add(Id.addComponent, 'Add Component', 'PO detail add component line button');
    register.add(Id.addGasket, 'Add Gasket', 'PO detail add gasket line button');
    register.add(Id.addFill, 'Add Glass', 'PO detail add fill (glass) line button');
    register.add(Id.fillSizeTitle, 'Glass Size', 'Ad-hoc fill (glass) width x height dialog title');
    register.add(Id.fillWidthLabel, 'Width', 'Ad-hoc fill width field label');
    register.add(Id.fillHeightLabel, 'Height', 'Ad-hoc fill height field label');
    register.add(Id.gasketLengthTitle, 'Gasket Length', 'Ad-hoc gasket length dialog title');
    register.add(Id.gasketLengthLabel, 'Length', 'Ad-hoc gasket length field label');
    register.add(Id.measurementOk, 'OK', 'Ad-hoc measurement-entry dialog confirm button');
    register.add(Id.measurementCancel, 'Cancel', 'Ad-hoc measurement-entry dialog cancel button');
  }
}
